<template>
  <div>
    <div class='title' @click="titleEdit = true">
      <el-input v-if="titleEdit" @blur="titleEdit = false" autofocus v-model="title" />
      <span v-if="!titleEdit">{{title}}</span>
    </div>
    <div class='body' @click="bodyEdit = true">
      <el-input type="textarea" v-if="bodyEdit" @blur="bodyEdit = false" autofocus v-model="body" />
      <span v-if="!bodyEdit">{{body}}</span>
    </div>
  </div>
</template>

<script lang="">
export default {
  // Options / Data
  data () {
    return {
      titleEdit : false,
      title     : 'a',
      bodyEdit  : false,
      body      : 'a'
    }
  },
  props    : [],
  computed : {},
  methods  : {}// ,
  // watch: {},
  // Options / DOM
  // el () {},
  // replace: true,
  // template: '',
  // Options / Lifecycle Hooks
  // init () {},
  // crated () {},
  // beforeCompile () {},
  // compiled () {},
  // ready () {},
  // attached () {},
  // detached () {},
  // beforeDestroy () {},
  // destroyed () {},
  // Options / Assets
  // directives: {},
  // elementDirectives: {},
  // filters: {},
  // components: {},
  // transitions: {},
  // partials: {},
  // Options / Misc
  // parent: null,
  // events: {},
  // mixins: [],
  // name: ''
}
</script>

<style scoped>
.title {
  text-align       : left;
  width            : 100%;
  height           : 20px;
  background-color : pink;
}

.body {
  text-align       : left;
  width            : 100%;
  min-height       : 60px;
  background-color : white;
}
</style>



// WEBPACK FOOTER //
// src/components/object/controller/card-generator.vue